export const theme = {
  name: 'bmw',
  primaryColor: null
}
